export const FETCH_ACCESS_LOG_LIST = 'accessLogs/FETCH_ACCESS_LOG_LIST';
export const FETCH_ACCESS_LOG_LIST_SUCCESS = 'accessLogs/FETCH_ACCESS_LOG_LIST_SUCCESS';

export const FETCH_ACCESS_LOG = 'accessLogs/FETCH_ACCESS_LOG';
export const FETCH_ACCESS_LOG_SUCCESS = 'accessLogs/FETCH_ACCESS_LOG_SUCCESS';
